mutation DataAccessPolicyDelete($input: DataAccessPolicyDeleteInput!) {
  dataAccessPolicyDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
